import React from 'react';
import SectionHeader from './SectionHeader';

export default function StatBlock({ data }) {
  return (
    <section className="section-pad relative">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 50% 50%, rgba(8,7,5,0.5) 0%, rgba(8,7,5,0.32) 60%, rgba(8,7,5,0.55) 100%)",
        }}
      />
      <div className="container-narrow relative">
        <SectionHeader chapter={data.chapter} label={data.label} heading={data.heading} />
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <p className="font-serif text-[19px] leading-[1.75] text-[color:var(--bx-bone)]/95 [text-shadow:0_2px_18px_rgba(0,0,0,0.7)]">{data.body}</p>
          </div>
          <div className="lg:col-span-7">
            <div
              className="grid grid-cols-1 md:grid-cols-2 gap-px"
              style={{ background: "rgba(200,161,74,0.18)" }}
            >
              {data.meta.map((m, i) => (
                <div
                  key={i}
                  className="p-6 backdrop-blur-md"
                  style={{ background: "rgba(11,9,8,0.62)" }}
                >
                  <div className="font-sc text-[10px] gold-text tracking-[0.42em] mb-2">{m.k}</div>
                  <div className="font-serif text-[18px] text-[color:var(--bx-bone)]/95">{m.v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
